import React from 'react';
import { Modal, Table } from 'antd';
import moment from 'moment';
import DragModal from '@/components/DragModal';
import styles from './index.module.less';
// log表格
const defaultLogColumns = [
  {
    title: '操作时间',
    dataIndex: 'create_time',
    width: 160,
    render: (_, row) =>
      row.create_time && moment(row.create_time * 1000).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    title: '操作内容',
    dataIndex: 'content',
  },
  {
    title: '操作人',
    dataIndex: 'account_name',
    width: 80,
  },
];
const LogModal = (props) => {
  const {
    handleCloseLogModal,
    isShowLogModal,
    logTitle = '操作日志',
    logModalData,
    logColumns = defaultLogColumns,
    logData,
    emitLogData,
    width,
    loading = false,
  } = props;
  const scrollX = logColumns.map((item) => item.width || 100).reduce((sum, num) => sum + num, 0);
  // 点击分页
  const pageChange = (pageNo, pageSize) => {
    let params = {};
    if (logData.page && logData.pageSize) {
      params = {
        ...logData,
        page: pageNo,
        pageSize,
      };
    } else {
      params = {
        ...logData,
        page_no: pageNo,
        page_size: pageSize,
      };
    }
    // 发送参数到父组件
    emitLogData(params);
  };
  const { page_size, page_no, total_num, page, pageSize, total } = logData;

  return (
    <DragModal
      className={styles.modalWarp}
      title={logTitle}
      visible={isShowLogModal}
      onOk={() => {}}
      onCancel={handleCloseLogModal}
      width={width || 700}
    >
      <Table
        loading={loading}
        scroll={{ y: 430, x: scrollX }}
        columns={logColumns}
        dataSource={logModalData}
        rowKey={(_, index) => index}
        pagination={{
          pageSize: pageSize || page_size,
          total: total_num || total,
          onChange: pageChange,
          current: page || page_no,
          showSizeChanger: true,
          showTotal: (totalNum) => `共${totalNum}条`,
        }}
      />
    </DragModal>
  );
};

export default LogModal;
